module.exports = __webpack_public_path__ + "img/shield-plus.771ea21a.svg";